import { Component, inject, ViewChild } from '@angular/core';
import { UsersListComponent } from './users-list/users-list.component';
import { BreadcrumbComponent } from '../elements/breadcrumb/breadcrumb.component';
import { USER_PERMISSIONS } from '../app.constants';
import { LocalStorageService } from '../services/local-storage.service';

@Component({
  selector: 'app-users',
  imports: [UsersListComponent, BreadcrumbComponent],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css'
})
export class UsersComponent {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Users',
    breadcrumb_url : '/admin/tenants'
  }
  @ViewChild(UsersListComponent) userList!: UsersListComponent;
  private authService = inject(LocalStorageService);

  addUserEvent(event : any){
    this.userList.addUserToggle();
  }

  get checkAddUser(){
        return this.authService.checkPermission(USER_PERMISSIONS.USERS.CREATE_USER);
  }
}
